import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { logPageView } from "services/analytics";
import RouteURLs from "RouteURLs";
import NextRouteURLs from 'NextRouteURLs';
import AuthLayout from "layouts/Authentication";
import LoginForm from "components/auth/LoginForm";
import { loadUser } from "services/auth";
import { getUserDefaultRoute } from "util/routing";
import { parseQueryString } from "util/url";
import "./index.scss";

export default class LoginPage extends Component<RouteComponentProps> {
  componentDidMount(): void {
    logPageView(this.props.location.pathname, "Login");
  }

  onLoggedIn = () => {
    const queryParams = parseQueryString(this.props.location.search);
    const redirect = queryParams["redirect"];
    if (redirect) {
      this.props.history.push(redirect);
    } else {
      loadUser().then(
        (user) => this.props.history.push(getUserDefaultRoute(user)),
        () => this.props.history.push(NextRouteURLs.HOME)
      );
    }
  };

  onRegister = () => {
    this.props.history.push(RouteURLs.REGISTER);
  };

  render() {
    return (
      <AuthLayout id="login-page">
        <section className="section--actions">
          <LoginForm
            onLoggedIn={this.onLoggedIn}
            onRegister={this.onRegister}
          />
        </section>
      </AuthLayout>
    );
  }
}
